import React, { Component } from "react";

class Privacy extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="privacy">
					<h1 className="mainPriv">Privacy Policy</h1>
					<h4>
						Your Personal data:{" "}
						<span className="personalData">
							(Username, profile pic, and Top Items)
						</span>{" "}
						will only be gathered by us for the purpose of providing a
						functional and user-intuitive website, including its contents like
						the game, and the services offered.
					</h4>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci
						ipsam nisi quibusdam molestiae excepturi voluptatem ea at rem alias
						minus, rerum optio voluptate qui libero magnam recusandae
						reprehenderit veritatis quasi. Lorem ipsum dolor sit amet,
						consectetur adipisicing elit. Adipisci ipsam nisi quibusdam
						molestiae excepturi voluptatem ea at rem alias minus, rerum optio
						voluptate qui libero magnam recusandae reprehenderit veritatis
						quasi.Lorem ipsum dolor sit amet, consectetur adipisicing elit.
						Adipisci ipsam nisi quibusdam molestiae excepturi voluptatem ea at
						rem alias minus, rerum optio voluptate qui libero magnam recusandae
						reprehenderit veritatis quasi.Lorem ipsum dolor sit amet,
						consectetur adipisicing elit. Adipisci ipsam nisi quibusdam
						molestiae excepturi voluptatem ea at rem alias minus, rerum optio
						voluptate qui libero magnam recusandae reprehenderit veritatis
						quasi.Lorem ipsum dolor sit amet, consectetur adipisicing elit.
						Adipisci ipsam nisi quibusdam molestiae excepturi voluptatem ea at
						rem alias minus, rerum optio voluptate qui libero magnam recusandae
						reprehenderit veritatis quasi.Lorem ipsum dolor sit amet,
						consectetur adipisicing elit. Adipisci ipsam nisi quibusdam
						molestiae excepturi voluptatem ea at rem alias minus, rerum optio
						voluptate qui libero magnam recusandae reprehenderit veritatis
						quasi.Lorem ipsum dolor sit amet, consectetur adipisicing elit.
						Adipisci ipsam nisi quibusdam molestiae excepturi voluptatem ea at
						rem alias minus, rerum optio voluptate qui libero magnam recusandae
						reprehenderit veritatis quasi.Lorem ipsum dolor sit amet,
						consectetur adipisicing elit. Adipisci ipsam nisi quibusdam
						molestiae excepturi voluptatem ea at rem alias minus, rerum optio
						voluptate qui libero magnam recusandae reprehenderit veritatis
						quasi.Lorem ipsum dolor sit amet, consectetur adipisicing elit.
						Adipisci ipsam nisi quibusdam molestiae excepturi voluptatem ea at
						rem alias minus, rerum optio voluptate qui libero magnam recusandae
						reprehenderit veritatis quasi.Lorem ipsum dolor sit amet,
						consectetur adipisicing elit. Adipisci ipsam nisi quibusdam
						molestiae excepturi voluptatem ea at rem alias minus, rerum optio
						voluptate qui libero magnam recusandae reprehenderit veritatis
						quasi.
					</p>
				</div>
			</React.Fragment>
		);
	}
}

export default Privacy;
